<template>
  <div class="merchant-auth-page-container design-auth-c">
    <div class="auth-page__group" v-for="(content, index) in contents" :key="index">
      <div class="group__title">{{ content.title }}</div>
      <div class="group__main-body">
        <div class="group__wrapper">
          <div class="group__item" v-for="(ad, a) in content.ads" :key="a">
            <div class="item__title">{{ ad.title }}</div>
            <div class="item__content">
              <p v-for="(text, t) in ad.content.split('\n')" :key="t">{{ text }}</p>
            </div>
            <div
              class="item__icon"
              :style="{
                backgroundImage: `url(${ad.icon})`
              }"
            ></div>
            <div class="item__desc"></div>
          </div>
        </div>
      </div>
      <div class="group__bt" v-if="content.price">
        <router-link to="/payment" class="bt__link"
          >前往认证￥<strong>{{ content.price }}</strong
          >/{{ content.usefulUnit }}</router-link
        >
      </div>
    </div>
    <div class="leading-words-c">
      <p>升级为设计企业店铺，请填写下方资料，平台会尽快联系您</p>
      <p>或可以致电我们：<a href="tel:4000218995">4000218995</a></p>
      <img src="../../../assets/images/icons/icon-down.jpg" alt="" srcset="">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contents: [
        {
          title: '设计企业特权',
          ads: [
            {
              title: '不限次',
              content: '认证设计师用户在\n手机端和电脑端无限次\n搜索材料和查看厂家电话\n还可按图搜材料，更方便',
              icon: require('@/assets/images/a-2-1.png'),
            },
            {
              title: '优秀案例共享计划',
              content: '设计企业可以发布优秀项目案例\n加入优秀案例共享计划，可以看到所有\n成员企业分享的项目案例和材料供应商，\n快速掌握热门材料不同玩法',
              icon: require('@/assets/images/a-2-1.png'),
            },
            {
              title: '产品资料下载',
              content: '设计企业可以下载任意材料商家发布在\n主页的产品资料，提高设计效率',
              icon: require('@/assets/images/a-1-3.png'),
            },
            {
              title: '供应商推荐',
              content: '根据设计单位业务需求，定制独家\n精选材料供应商库，大大提升设计\n师效率及材料品牌沟通效率',
              icon: require('@/assets/images/a-1-4.png'),
            },
            {
              title: '需求优先解决',
              content: '无限次发布材料需求\n平台有专人优先解决并会持续跟进\n确保设计企业找到心仪的材料\n提高设计效率',
              icon: require('@/assets/images/a-2-5.png'),
            },
            {
              title: '自动生成材料清单',
              content: '看到项目合适的材料可以添加至材料清单\n并支持生成材料清单，提高工作效率神器',
              icon: require('@/assets/images/a-2-6.png'),
            },
            {
              title: '预约材料宣讲',
              content: '设计企业可以免费在线预约线上&线下\n材料宣讲，平台合作国内外优秀材料品\n牌可供挑选，还可在材料企业主页查看\n往期宣讲视频',
              icon: require('@/assets/images/a-2-8.png'),
            },
            {
              title: '公众号发布',
              content: '厂家旗舰店可以将公司的公众号文章\n轻松发布到网站和小程序平台，\n实现粉丝转化',
              icon: require('@/assets/images/a-2-7.png'),
            },
          ],
          // price: 2999,
          // usefulUnit: '3个月',
        },
        {
          title: '设计师特权',
          ads: [
            {
              title: '不限次',
              content: '认证设计师用户在\n手机端和电脑端无限次\n搜索材料和查看厂家电话\n还可按图搜材料，更方便',
              icon: require('@/assets/images/a-1-1.png'),
            },
            {
              title: '案例发布',
              content: '无限次发布自己设计的案例\n可转发分享，打造自己的设计主页',
              icon: require('@/assets/images/a-1-2.png'),
            },
            {
              title: '需求发布',
              content: '无限次发布材料需求\n让材料厂家主动联系，提高设计效率',
              icon: require('@/assets/images/a-1-3.png'),
            },
            {
              title: '智能推荐',
              content: '根据您的搜索偏好，系统自动推荐相匹配\n的材料产品和厂家',
              icon: require('@/assets/images/a-1-4.png'),
            },
          ],
          // price: 60,
          // usefulUnit: '3个月',
        },
      ],
    };
  },
};
</script>

<style lang="scss">
  .leading-words-c {
    font-size: 20px;
    text-align: center;
    line-height: 40px;
    img {
      margin: 0 auto;
      width: 100px;
    }
    a {
      font-weight: 600;
    }
  }
  .design-auth-c {
    .item__content {
      z-index: 1;
    }
  }
</style>
